module.exports = __webpack_public_path__ + "static/mecanicoElectrico-723224c3854b864738be53596ba622c3.jpg";